import { Pasco } from "@src/domain/pascos/entities/pasco.entity";
import { AcademicYear } from "@src/domain/pascos/value_objects/academic_year";
import type { ProcessingStatus } from "@src/domain/pascos/value_objects/processing_status";
import { UniqueEntityID } from "@src/domain/pascos/value_objects/unique_entity_Id";
import { createUploadedBy } from "@src/domain/pascos/value_objects/uploaded_by";

export class PascoMap {
    static toDomain(raw: any): Pasco {
        return Pasco.create(
            {
                path: raw.path,
                courseCode: raw.course_code ?? null,
                courseName: raw.course_name ?? null,
                academicYear: raw.academic_year ? AcademicYear.create(raw.academic_year) : null,
                semester: raw.semester ?? null,
                courseDescription: raw.course_description ?? null,
                department: raw.department ?? null,
                level: raw.level ?? null,
                isInterimAssessment: raw.is_interim_assessment,
                isSupplementary: raw.is_supplementary,
                processingStatus: raw.processing_status as ProcessingStatus,
                isApproved: raw.is_approved,
                isReviewed: raw.is_reviewed,
                universityId: raw.university_id,
                uploadedBy: raw.uploaded_by ? createUploadedBy(
                    raw.uploaded_by.user_id,
                    raw.uploaded_by.name,
                    raw.uploaded_by.profile_picture
                ) : undefined,
                createdAt: raw.created_at ? new Date(raw.created_at) : new Date(),
                updatedAt: raw.updated_at ? new Date(raw.updated_at) : new Date(),
            },
            new UniqueEntityID(raw.pasco_id)
        );
    }

    static toPersistence(pasco: Pasco): any {
        return {
            pasco_id: pasco.pascoId,
            path: pasco.path,
            course_code: pasco.courseCode,
            course_name: pasco.courseName,
            academic_year: pasco.academicYear,
            semester: pasco.semester,
            course_description: pasco.courseDescription ?? null,
            department: pasco.department ?? null,
            level: pasco.level,
            is_interim_assessment: pasco.isInterimAssessment,
            is_supplementary: pasco.isSupplementary,
            processing_status: pasco.processingStatus,
            is_approved: pasco.isApproved,
            is_reviewed: pasco.isReviewed,
            university_id: pasco.universityId,
            uploaded_by: pasco.uploadedBy ? {
                user_id: pasco.uploadedBy.userId,
                name: pasco.uploadedBy.name,
                profile_picture: pasco.uploadedBy.profilePicture,
            } : undefined,
            created_at: pasco.createdAt.toISOString(),
            updated_at: pasco.updatedAt.toISOString(),
        };
    }
}
